import React from 'react';
import { MessageCircle, ArrowDown } from 'lucide-react';
import './FloatingContactButton.css';

interface FloatingContactButtonProps {
  isVisible: boolean;
  onClick: () => void;
}

/**
 * フローティングお問い合わせボタンコンポーネント
 */
const FloatingContactButton: React.FC<FloatingContactButtonProps> = ({
  isVisible,
  onClick
}) => {
  return (
    <div 
      className={`floating-contact-button ${isVisible ? 'visible' : ''}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      aria-label="お問い合わせフォームへスクロール"
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div className="floating-button-content">
        <div className="floating-button-icon">
          <MessageCircle size={20} />
        </div>
        <span className="floating-button-text">
          お問い合わせをする
        </span>
        <div className="floating-button-arrow">
          <ArrowDown size={16} />
        </div>
      </div>
      
      {/* リップル効果 */}
      <div className="floating-button-ripple"></div>
    </div>
  );
};

export default FloatingContactButton;